import React from 'react';
import { Button, Icon } from '@innovationnorway/cl-react';
import saveAs from 'file-saver';
import ContentPage from 'src/components/ContentPage/ContentPage';
import { useSivaContractDataExtract } from 'src/features/siva/ideas-and-companies/hooks/use-siva-contract-data-extract';
import { useTranslation } from 'react-i18next';
import DocumentTitle from 'src/components/DocumentTitle/DocumentTitle';
import useDocumentTitle from 'src/hooks/use-document-title';
import { LoadingPage } from 'src/components/LoadingPage/LoadingPage';

const ExtractKtu = () => {
  const { downloadKtuData } = useSivaContractDataExtract();
  const { t: tSiva } = useTranslation('siva');
  const { t: tPageTitles } = useTranslation('pageTitles');
  const { documentTitle } = useDocumentTitle(tPageTitles('sivaReporting'));

  if (downloadKtuData.isLoading) {
    return (
      <DocumentTitle title={documentTitle}>
        <LoadingPage />
      </DocumentTitle>
    );
  }

  return (
    <ContentPage title={tSiva('export.ktu.header')} documentTitle={tPageTitles('sivaReporting')}>
      <Button
        type="button"
        variant="tertiary"
        onClick={async () => {
          const file = await downloadKtuData.mutateAsync(true);
          saveAs(file.data, file.fileName);
        }}
      >
        <Icon prefix="fasr" iconName="file-export" />
        {tSiva('export.ktu.exportButton')}
      </Button>
    </ContentPage>
  );
};

export default ExtractKtu;
